import Footer from 'components/modules/landing/alternate/Footer';
import Faq from 'components/modules/showcase/FaqHowWeWork';
import AboutTheFounder from 'components/modules/showcase/AboutTheFounder';
import DefaultLandingNavbar from 'components/navbars/default-landing-navbar/DefaultLandingNavbar';
import { Card, Row } from 'react-bootstrap';
import YouTubeEmbed from 'components/modules/showcase/YouTubeEmbed';
import smarterNutrition from 'assets/img/bg/smarter_nutrition_updated.png';

const HowWeWorks = () => {
  return (
    <>
      <div className="bg-body-emphasis dark__bg-gray-1200">
        <DefaultLandingNavbar className="dark__bg-gray-1200" />
        <div className="container">
          <Row className="flex-center py-5">
            <h2 className="text-center py-5">How MLAS Works</h2>

            <Card>
              <Card.Body>
                <Card.Text>
                  <h3>A Smarter Way to Understand What You Eat</h3>
                  <p>
                    MLAS (ملّاس) is more than a food-logging app — it’s a
                    complete nutrition management system created in Kuwait by
                    nutritionists for nutritionists.{' '}
                  </p>
                  <ol>
                    <li>
                      <h5>Snap a Photo of Your Meal:</h5>
                      <p>
                        Take a quick picture before you eat, log in the
                        ingredients and portions using the search bar. — That’s
                        it.{' '}
                      </p>
                      <p>Your food log is saved securely to your profile. </p>
                      <p>
                        (Our AI food recognition system launches in March 2026,
                        bringing full automation to this step.){' '}
                      </p>
                    </li>
                    <li>
                      <h5>Log What You Ate:</h5>
                      <p>
                        After snapping your meal, search for your food using our
                        built-in database powered by the{' '}
                        <strong>USDA Food Database.</strong>{' '}
                      </p>
                      <p>
                        Select your items and portion sizes — MLAS will
                        calculate your total calories, protein, carbohydrates,
                        fats, and key nutrients instantly and send them to your
                        clinic instantly.
                      </p>
                    </li>
                    <li>
                      <h5>Your Dietitian Gets the Full Picture:</h5>
                      <p>
                        Once your meal is logged, MLAS automatically sends your
                        nutrition summary to your assigned{' '}
                        <strong>dietitian.</strong>
                      </p>
                      <p>
                        Your dietitian can review your progress, monitor your
                        intake, and send personalized recommendations — all
                        through a secure and private system.
                      </p>
                    </li>
                    <li>
                      <h5>Real-Time Insights & Progress Tracking:</h5>
                      <p>Your dashboard displays: </p>
                      <img
                        src={smarterNutrition}
                        alt=""
                        className="w-50 d-dark-none rounded-2"
                      />
                    </li>
                    <li>
                      <h5>Annual Subscription — Simple and Transparent:</h5>
                      <p>
                        MLAS operates on a{' '}
                        <strong>yearly subscription model</strong> for clients
                        and dietitians.{' '}
                      </p>
                      <p>
                        Subscribers receive access to all platform features,
                        regular updates, and early access to upcoming AI tools.
                      </p>
                    </li>
                    <li>
                      <h5>Coming March 2026 — AI Camera Recognition:</h5>
                      <p>
                        We’re introducing our next major feature: <br />
                        AI-powered food recognition, trained on thousands of
                        regional dishes. <br />
                        The new system will automatically identify your meals,
                        estimate portion sizes, and log nutrients instantly — no
                        manual typing required.{' '}
                      </p>
                      <p>
                        This innovation is being developed in collaboration with
                        Kuwaiti dietitians and researchers to ensure cultural
                        accuracy and precision.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Built for Professionals, Designed for You:</h5>
                      <p>
                        MLAS isn’t just an app — it’s a trusted bridge between{' '}
                        <strong>patients and professionals.</strong>{' '}
                      </p>
                      <p>
                        By combining advanced data analysis with human
                        expertise, MLAS helps improve nutrition awareness,
                        diabetes prevention, and public health across Kuwait and
                        the Gulf region.
                      </p>
                    </li>
                    <li>
                      <h5>Secure, Private, and Culturally Rooted:</h5>
                      <p>
                        All data on MLAS is encrypted and stored securely in
                        compliance with{' '}
                        <strong>Kuwait’s data protection laws</strong> and{' '}
                        <strong>HIPAA standards.</strong>{' '}
                      </p>
                      <p>
                        Your information is never shared without your consent.
                        Because in our culture, trust comes first.{' '}
                      </p>
                    </li>
                  </ol>
                </Card.Text>
                <YouTubeEmbed url="https://youtu.be/CH6StTBRCn4" />
              </Card.Body>
            </Card>
          </Row>
          <Row id="faq" className="flex-center my-5">
            <Card>
              <Card.Body>
                <Faq />
              </Card.Body>
            </Card>
          </Row>
          <Row className="flex-center mb-5">
            <Card>
              <Card.Body>
                <AboutTheFounder />
              </Card.Body>
            </Card>
          </Row>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default HowWeWorks;
